<template>
    <main-layout :hide-alerts="true" :containerFluid="true">
        <template v-slot:header>
            <v-toolbar-title class="d-flex justify-space-between align-center">
                <h1 class="text-truncate font-weight-bold text-h4">{{$t('Hotel Reservations')}}</h1>
            </v-toolbar-title>
        </template>
        <template v-slot:body>
            <div
                v-if="(reservations && !reservations.length) && !isLoading"
                class="pa-3 d-flex align-center"
            >
                <v-icon>mdi-calendar-remove-outline</v-icon>
                <p class="mb-0 ml-2 text-subtitle-1">
                    {{ $t('You do not have any reservations') }}.
                </p>
            </div>

            <template v-if="reservations && reservations.length">
                <hotel-reservations-in-table
                    :reservations="reservations"
                    @cancel-reservation="openCancelReservationModal"
                />
                <pagination
                    :resource="pagination"
                    :overwrite-path="url"
                    @load="load"
                />
            </template>

            <modal
                :show="showCancelReservationModal"
                :title="$t('reservationCancelConfirmModal.title')"
                :description="$t('reservationCancelConfirmModal.description')"
                :loading="loading"
                :sticky-header="true"
                @save="cancelReservation"
                @close="showCancelReservationModal = false"
                save-text="Confirm"
                primary-button-class="red white--text"
                hide-top-close-button
                max-width="450"
            />

            <modal
                :show="showCancelReservationResponseModal"
                :title="$t('Reservation cancelled')"
                :loading="loading"
                :sticky-header="true"
                @close="showCancelReservationResponseModal = false"
                @save="showCancelReservationResponseModal = false"
                save-text="OK"
                hide-top-close-button
                hide-actions-cancel
                max-width="450"
            >
                <div class="pa-4">
                    <b>{{ $t('hotelReservationCancelResponseModal.description') }}</b>
                    <template v-if="cancelledReservation">
                        <br><br>
                        <div
                            v-if="cancelledReservation.refundable && cancelledReservation.amountRefunded"
                            v-html="$t('hotelReservationCancelResponseModal.refund_details', {price: `${getCurrencySymbol(cancelledReservation.currency)} ${cancelledReservation.amountRefunded}`})"
                        ></div>
                        <template v-else class="mb-2">
                            {{ $t('hotelReservationCancelResponseModal.no_refund') }}
                        </template>
                        <template
                            v-if="cancelledReservation.cancellationFee"
                            class="mt-4"
                        >
                            <br>
                            {{ $t('Cancellation fee') }}: <b>{{ getCurrencySymbol(cancelledReservation.currency) }} {{ cancelledReservation.cancellationFee }}</b>
                        </template>
                    </template>
                </div>
            </modal>

            <hotel-reservation-preview-modal/>
        </template>
    </main-layout>
</template>

<script>
import axios from 'axios';
import HotelReservationsInTable from '@/components/reservations/HotelReservationsInTable.vue';
import Pagination from '@/components/Pagination.vue';
import HotelReservationPreviewModal from '@/components/reservations/HotelReservationPreviewModal.vue';
import { mapGetters } from 'vuex';
import CurrencyMixin from '@/lib/CurrencyMixin';

export default {
  components: { HotelReservationsInTable, Pagination, HotelReservationPreviewModal },
  mixins: [CurrencyMixin],
  data() {
    return {
      reservations: [],
      pagination: {},
      url: '/my-travel/hotel-reservations',

      showCancelReservationModal: false,
      showCancelReservationResponseModal: false,

      cancelReservationId: null,
      cancelledReservation: null,
    };
  },
  mounted() {
    this.$title = this.$t('Hotel Reservations');
    this.load();
  },
  computed: {
    ...mapGetters(['loading']),
    isLoading() {
      return this.$store.getters.loading;
    },
  },
  methods: {
    load(url = this.url) {
      this.$store.dispatch('loading', true);
      axios
        .get(url)
        .then(({ data }) => {
          this.pagination = data;
          this.reservations = data.data && data.data.length ? data.data : data;
          this.$store.dispatch('loading', false);
        })
        .catch((error) => {
          console.log('Reservations load error: ', error);
          this.$store.dispatch('loading', false);
        });
    },
    cancelReservation() {
      if (this.loading) {
        return;
      }
      this.$store.dispatch('loading', true);
      axios
        .put(`hotels/reservations/${this.cancelReservationId}`)
        .then((response) => {
          if (response.data.data) {
            this.cancelledReservation = response.data.data;
            this.showCancelReservationResponseModal = true;
          }
          this.$store.dispatch('message', this.$t('Reservation cancelled successfuly'));
          this.load();
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {
            this.$store.dispatch('setErrors', [error.response.data.errors]);
          }
        })
        .finally(() => {
          this.showCancelReservationModal = false;
          this.$store.dispatch('loading', false);
        });
    },
    openCancelReservationModal(id) {
      this.cancelReservationId = id;
      this.showCancelReservationModal = true;
    },
  },
};
</script>
